import { render, staticRenderFns } from "./ServiceCancellationPolicy.vue?vue&type=template&id=fc21173a"
import script from "./ServiceCancellationPolicy.vue?vue&type=script&lang=js"
export * from "./ServiceCancellationPolicy.vue?vue&type=script&lang=js"
import style0 from "./ServiceCancellationPolicy.vue?vue&type=style&index=0&id=fc21173a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports